import { Box, TextField, RadioGroup, FormControlLabel, Radio, Typography, Checkbox } from '@mui/material';
import React from 'react';

const CustomInput = ({
    label,
    height,
    required,
    value,
    onChange,
    disabled= false,
    name,
    error,
    helperText,
    type = 'text',
    placeholder,
    options = []
}) => {
    return (
        <Box display="flex" flexDirection="column" gap={1} width="100%" mt={2}>
            {type === 'radioGroup' ? (
                <>
                    {/* <Typography variant="subtitle2" sx={{ fontSize: '18px' }}>
                        {label} {required && <span style={{ color: 'red' }}>*</span>}
                    </Typography> */}
                    <RadioGroup
                        row
                        name={name}
                        value={value}
                        onChange={onChange}
                    >
                        {options.map((option) => (
                            <FormControlLabel
                                key={option.value}
                                value={option.value}
                                control={<Radio />}
                                label={option.label}
                            />
                        ))}
                    </RadioGroup>
                    {helperText && <Typography variant="caption" color="error">{helperText}</Typography>}
                </>
            ) : (type === 'checkbox') ? (
                    <FormControlLabel
                      control={
                        <Checkbox
                          name={name}
                          checked={value}
                          onChange={onChange}
                        />
                      }
                      label={label}
                    />
            ) : (
                <TextField
                    label={label}
                    fullWidth
                    name={name}
                    value={value}
                    type={type}
                    onChange={onChange}
                    disabled={disabled}
                    error={error}
                    helperText={helperText}
                    placeholder={placeholder}
                    InputLabelProps={{
                        shrink: true,
                    }}
                    sx={{
                        '& .MuiInputLabel-root': {
                            fontSize: '18px',
                            background: "white",
                            '&::after': {
                                content: required ? '"*"' : '""',
                                color: 'red',
                                marginLeft: '2px',
                                background: "white",
                            },
                        },
                        '& .MuiOutlinedInput-root': {
                            borderRadius: '8px',
                            height: height,
                            '& fieldset': {
                                borderColor: error ? 'red' : 'black',
                            },
                            '&:hover fieldset': {
                                borderColor: error ? 'red' : 'black',
                            },
                            '&.Mui-focused fieldset': {
                                borderColor: error ? 'red' : 'black',
                            },
                        },
                    }}
                />
            )}
        </Box>
    );
};

export default CustomInput;
